import React, { useContext, useEffect, useState } from "react";
import { UserContext } from "./UserContext";
import Comment from "./Comment";
import config from "./config";
export default function CommentSection({ postId }) {
  const { userInfo } = useContext(UserContext);
  const [comments, setComments] = useState([]);
  const [commentContent, setCommentContent] = useState("");
  const [guestUsername, setGuestUsername] = useState("");

  useEffect(() => {
    fetch(`${config.apiUrl}/post/${postId}/comments`)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        setComments(data); // Set the fetched comments
      })
      .catch((err) => {
        console.error("Error fetching comments:", err);
      });
  }, [postId]);

  const username = userInfo?.username;

  async function addNewComment(event) {
    event.preventDefault();

    const data = {
      text: commentContent,
      guestUsername: !username ? guestUsername : undefined,
    };

    try {
      const response = await fetch(`${config.apiUrl}/post/${postId}/comments`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
        credentials: "include",
      });
      if (response.ok) {
        setCommentContent("");
        setGuestUsername("");
      } else {
        const errorData = await response.json();
        alert(
          errorData.error || "An error occurred while submiting your comennt",
        );
      }
    } catch (error) {
      console.error("Error submiting comment", error);
      alert("An unexpected error ocurred");
    }
  }

  return (
    <div className="comments-section">
      <div className="add-comment">
        <form className="comment-form" onSubmit={addNewComment}>
          {username ? (
            <input type="text" value={userInfo.username} readOnly />
          ) : (
            <input
              type="text"
              placeholder="Your Nickname"
              value={guestUsername}
              onChange={(ev) => setGuestUsername(ev.target.value)}
              required
              maxLength={20}
            />
          )}
          <textarea
            type="text"
            placeholder="Leave a comment"
            value={commentContent}
            onChange={(ev) => setCommentContent(ev.target.value)}
            required
          />
          <button className="forms-button">
            <span>Submit</span>
          </button>
        </form>
      </div>
      {comments.map((comment) => (
        <Comment
          key={comment._id}
          postId={postId}
          author={comment.author}
          userId={comment.userId}
          text={comment.text}
          date={comment.createdAt}
          commentId={comment._id}
          replies={comment.replies}
        />
      ))}
    </div>
  );
}
